import Card from "components/card";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { currentUser } from "services/users/authSlice";
import { BsThreeDots } from "react-icons/bs";
import { TbUserEdit } from "react-icons/tb";
import { PiPassword } from "react-icons/pi";
import TextWithlabel from "./TextWithLabel";
import UserInfoEditModal from "./modal/UserInfoEditModal";
import PasswordChangeModal from "./modal/PasswordChangeModal";

const UserInfo = () => {
  const user = useSelector(currentUser);
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [showUserEditModal, setShowUserEditModal] = useState(false);
  const [showPasswordChangeModal, setShowPasswordChangeModal] = useState(false);

  const toggleDropdown = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  return (
    <Card extra={"w-full h-full p-4"}>
      <div className="relative mb-3 flex items-center justify-between pt-1">
        <h4 className="text-xl font-bold text-navy-700 dark:text-white">
          Хэрэглэгчийн мэдээлэл
        </h4>
        <div className="relative inline-block text-left">
          <button
            onClick={toggleDropdown}
            className="linear flex items-center justify-center rounded-lg bg-lightPrimary p-2 text-xl font-bold text-brand-500 transition duration-200 hover:cursor-pointer hover:bg-gray-100 dark:bg-navy-700 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/10"
          >
            <BsThreeDots className="h-6 w-6" />
          </button>

          {isDropdownOpen && (
            <div className="absolute right-0 z-50 mt-2 w-max rounded-xl bg-white py-3 px-4 text-sm shadow-xl dark:bg-navy-700 dark:shadow-none">
              <p
                className="flex cursor-pointer items-center gap-2 text-gray-600 hover:font-medium hover:text-black"
                onClick={() => {
                  setDropdownOpen(false);
                  setShowUserEditModal(true);
                }}
              >
                {/* Add your icon component here */}
                <span>
                  <TbUserEdit />
                </span>
                Хэрэглэгчийн мэдээлэл засах
              </p>
              <p
                className="mt-2 flex cursor-pointer items-center gap-2 pt-1 text-gray-600 hover:font-medium hover:text-black"
                onClick={() => {
                  setDropdownOpen(false);
                  setShowPasswordChangeModal(true);
                }}
              >
                <span>
                  <PiPassword />
                </span>
                Нууц үг солих
              </p>
            </div>
          )}
        </div>
      </div>

      <div className="mb-6 mt-4 grid items-end gap-6 md:grid-cols-2">
        <TextWithlabel
          id={1}
          label="Хэрэглэгчийн нэр"
          text={user.username ?? "-"}
        />
        <TextWithlabel id={2} label="Регистер" text={user.register ?? "-"} />
        <TextWithlabel id={3} label="Овог" text={user.lastname ?? "-"} />
        <TextWithlabel id={4} label="Нэр" text={user.firstname ?? "-"} />
        <TextWithlabel id={5} label="Имэйл" text={user.email ?? "-"} />
        <TextWithlabel id={6} label="Утас" text={user.phone ?? "-"} />
        <TextWithlabel
          id={7}
          label="Хүйс"
          text={user.gender ? "Эрэгтэй" : "Эмэгтэй"}
        />
      </div>

      {showUserEditModal ? (
        <UserInfoEditModal setShowModal={setShowUserEditModal} />
      ) : null}
      {showPasswordChangeModal ? (
        <PasswordChangeModal
          id={user.id}
          setShowModal={setShowPasswordChangeModal}
        />
      ) : null}
    </Card>
  );
};

export default UserInfo;
